function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.889 4.15L10 1.9l7.111 2.7-.444 9L10 19l-7.111-5.4V4.15z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.683 1.094a.579.579 0 01.634 0 17.363 17.363 0 007.192 2.724c.282.04.491.277.491.557v5.063c0 4.377-2.637 7.571-7.795 9.524a.58.58 0 01-.41 0C4.637 17.01 2 13.815 2 9.438V4.375c0-.28.21-.517.49-.557a17.363 17.363 0 007.193-2.724zm7.174 3.762a18.432 18.432 0 01-6.399-2.342L10 2.234l-.458.28a18.431 18.431 0 01-6.4 2.342v4.582c0 3.816 2.25 6.596 6.858 8.396 4.608-1.8 6.857-4.58 6.857-8.396V4.856z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#dark_svg__clip0_9280_110312)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 8.167C6 7.522 6.512 7 7.143 7h5.714C13.488 7 14 7.522 14 8.167v2.916c0 .47-.273.876-.665 1.06a.873.873 0 00-.158-.22L10.893 9.59a.844.844 0 00-.934-.19.875.875 0 00-.53.808v2.042H7.144A1.155 1.155 0 016 11.083V8.167zm4.488 1.835a.281.281 0 00-.312-.063.292.292 0 00-.176.27v3.5c0 .125.079.236.195.276a.282.282 0 00.32-.102l.77-1.05h1.286c.116 0 .22-.07.264-.18a.296.296 0 00-.062-.318l-2.285-2.333z",
  fill: "#28293D"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "dark_svg__clip0_9280_110312"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(6 7)",
  d: "M0 0h8v7H0z"
})));

function SvgDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgDark;